// extracted by mini-css-extract-plugin
export default {"wrapper":"LSUXS","toolbox":"F2adO","image":"mKPJ4","image--highlighted":"aZFEZ","spinner":"LJ6zO"};